export default "__VITE_ASSET__Dl_lQ2r5__"